import type { UserNotification } from '../../types/notification';

const UUID_REGEX = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

export const isUuid = (value?: string): value is string => !!value && UUID_REGEX.test(value);

/** Media approval maId (uuid) for review / details modals. */
export const resolveApprovalMaId = (notification: UserNotification): string | undefined => {
  if (notification.reelId) { return notification.reelId; }
  if (notification.mediaId && isUuid(notification.mediaId)) { return notification.mediaId; }
  return undefined;
};
